namespace Roodik.Game
{
	import Graphics = PIXI.Graphics;
	import IAnalytics = Roodik.Core.IAnalytics;
	import IGameResources = Roodik.Core.IGameResources;
	import ISoundManager = Roodik.Core.ISoundManager;
	import SoundManager = Roodik.Core.SoundManager;
	import IStorageManager = Roodik.Core.IStorageManager;
	import StorageManager = Roodik.Core.StorageManager;
	import LocalizationManager = Roodik.Core.LocalizationManager;
	import IAdvertisment = Roodik.Core.IAdvertisment;
	
	export class GameLifeCycle
	{
		private _graphics : Graphics;
		private _gamePanel : GamePanel;
		private _gameCompletePanel : GameCompletePanel;
		private _menu : MenuView;
		private _sponsorHelp : SponsorPanelView;
		private _timesUpPanel : TimesUpPanelView;
		private _noMoreMovesPanelView : NoMoreMovesPanelView;
		private _loadingGameAssets : LazyGameAssetsLoaderView;
		private _progress:number = 1;
		private _soundManager:ISoundManager;
		private _storageManager:IStorageManager;
		private _localizationManager:LocalizationManager;
		private _ad:IAdvertisment;
		
		public constructor(private _container : PIXI.Container,
		                   private _width:number,
		                   private _height:number,
		                   private _analytics:IAnalytics,
		                   private _resources:IGameResources)
		{
			this._storageManager = new StorageManager("mahjong-treasure-island-");
			this._soundManager = new SoundManager(this._storageManager);
			
			document.addEventListener("visibilitychange", () =>
			{
				this.windowFocusChanged(document.hidden);
			});
			
			window.onpageshow = () => { this.windowFocusChanged(false); };
			
			window.onpagehide = () => { this.windowFocusChanged(true); };
			
			window.onfocus = () => { this.windowFocusChanged(false); };
			
			window.onblur = () => { this.windowFocusChanged(true); };

			this._ad = Roodik.Core.AdvertismentFactory.getProvider(Core.AdvertismentProvider.GAMEDISTRIBUTION, {
				id:"b7f28ffb3ada401dbc21dcbbc8c5cf74",
				debug:false
			},
			this._soundManager);

			/*this._ad = Roodik.Core.AdvertismentFactory.getProvider(Core.AdvertismentProvider.CLOUDGAMES, {
				id:565,
				debug:false
			},
			this._soundManager);*/

			this._ad.pauseGameEvent.on(this.stopGame.bind(this));
			this._ad.resumeGameEvent.on(this.continueGame.bind(this));
		}

		private stopGame()
		{
			this._analytics.sendEvent("Ad","Showed","");
			this.windowFocusChanged(true);
		}

		private continueGame()
		{
			this._analytics.sendEvent("Ad","Hided","")
			this.windowFocusChanged(false);
		}
		
		private windowFocusChanged(haveToMuteSounds:boolean)
		{
			this._soundManager.windowFocusChanged(haveToMuteSounds);
			haveToMuteSounds ? this.pauseGame() : this.unPauseGame();
		}

		private pauseGame()
		{
			if (this._gamePanel != null)
			{
				this._gamePanel.paused = true;
			}
		}

		private unPauseGame()
		{
			if (this._gamePanel != null)
			{
				this._gamePanel.paused = !this._gamePanel.interactiveChildren;
			}
		}
		
		public run()
		{
			this._localizationManager = new LocalizationManager(this._resources.getResourceByName("LocalizationData").data);
			this.showIntro();
		}
		
		private showIntro()
		{
			let introPanel = new IntroPanel(this._localizationManager, this._soundManager, this._analytics, this._ad);
			introPanel.events.once(IntroPanel.PLAY, (difficulty:LevelDifficulty) =>
			{
				introPanel.destroy();
				this._container.removeChild(introPanel);
				introPanel = null;
				this.showGame(difficulty);
			});
			this._container.addChild(introPanel);
		}
		
		private showGame(difficulty:LevelDifficulty)
		{
			this._ad.fetch();

			this._gamePanel = new GamePanel(this._storageManager, this._resources, this._soundManager, this._analytics);
			let levelCompleteCall = () =>
			{
				this.showLevelComplete();
			};
			let gameCompleteCall = () =>
			{
				this.showGameComplete();
			};
			let showMenu = () =>
			{
				this.showMenuPanel();
			};
			let askForHelp = ()=>
			{
				this.askForHelpReshuffle();
			};
			let timesUp = ()=>
			{
				this.timesUp();
			};
			let noMoreMoves = ()=>
			{
				this.noMoreMoves();
			};
			let onLoadingAssets = ()=>
			{
				this.onLoadingAssets();
			};
			let onLoadedAssets = ()=>
			{
				this.onLoadedAssets();
			};

			this._gamePanel.events.once(GamePanel.GAME_OVER, () =>
			{
				console.log("GAME OVER")

				this._gamePanel.events.off(GamePanel.LEVEL_COMPLETE, levelCompleteCall, this);
				this._gamePanel.events.off(GamePanel.GAME_COMPLETE, gameCompleteCall, this);
				this._gamePanel.events.off(GamePanel.SHOW_MENU, showMenu, this);
				this._gamePanel.events.off(GamePanel.ASKED_FOR_HELP, askForHelp, this);
				this._gamePanel.events.off(GamePanel.TIMES_UP, timesUp, this);
				this._gamePanel.events.off(GamePanel.HAS_NO_MOVES, noMoreMoves, this);
				this._gamePanel.events.off(GamePanel.ASSETS_LOADING, onLoadingAssets, this);
				this._gamePanel.events.off(GamePanel.ASSETS_LOADED, onLoadedAssets, this);
				levelCompleteCall = null;
				showMenu = null;
				askForHelp = null;
				onLoadingAssets = null;
				onLoadedAssets = null;

				// this.showGameOver();
			}, this);

			this._gamePanel.events.on(GamePanel.LEVEL_COMPLETE, levelCompleteCall, this);
			this._gamePanel.events.on(GamePanel.GAME_COMPLETE, gameCompleteCall, this);
			this._gamePanel.events.on(GamePanel.SHOW_MENU, showMenu, this);
			this._gamePanel.events.on(GamePanel.ASKED_FOR_HELP, askForHelp, this);
			this._gamePanel.events.on(GamePanel.TIMES_UP, timesUp, this);
			this._gamePanel.events.on(GamePanel.HAS_NO_MOVES, noMoreMoves, this);
			this._gamePanel.events.on(GamePanel.ASSETS_LOADING, onLoadingAssets, this);
			this._gamePanel.events.on(GamePanel.ASSETS_LOADED, onLoadedAssets, this);

			this._container.addChild(this._gamePanel);
			this._gamePanel.initialize();
		}

		private onLoadingAssets()
		{
			this.createUnderground();

			this._loadingGameAssets = new LazyGameAssetsLoaderView();
			this._container.addChild(this._loadingGameAssets);
		}

		private onLoadedAssets()
		{
			this.removeUnderground();

			this._container.removeChild(this._loadingGameAssets);
			this._loadingGameAssets.destroy();
			this._loadingGameAssets = null;
		}

		private noMoreMoves()
		{
			this.createUnderground();

			this._noMoreMovesPanelView = new NoMoreMovesPanelView(this._localizationManager,
			this._gamePanel.totalScore(),
			this._soundManager,
			this._analytics,
			()=>{
				// this._ad.show(false);
				this._container.removeChild(this._noMoreMovesPanelView);
				this._noMoreMovesPanelView.destroy();
				this.removeUnderground();

				this.playAgain();
			});
			this._container.addChild(this._noMoreMovesPanelView);
		}

		private timesUp()
		{
			this.createUnderground();

			this._timesUpPanel = new TimesUpPanelView(this._localizationManager,
			this._gamePanel.totalScore(),
			this._soundManager,
			this._analytics,
			()=>{
				// this._ad.show(false);
				this._container.removeChild(this._timesUpPanel);
				this._timesUpPanel.destroy();
				this.removeUnderground();

				this.playAgain();
			});
			this._container.addChild(this._timesUpPanel);
		}

		private showMenuPanel()
		{
			this._soundManager.playSound("click.mp3", 1);
			this.createUnderground();
			this._menu = new MenuView(this._localizationManager,
			this._soundManager,()=>{
				this._container.removeChild(this._menu);
				this._menu.destroy();
				this._menu = null;
				this.removeUnderground();
			});
			this._container.addChild(this._menu);
		}

		private askForHelpReshuffle()
		{
			this._soundManager.playSound("click.mp3", 1);

			this.createUnderground();

			this._sponsorHelp = new SponsorPanelView(this._localizationManager, this._soundManager, this._analytics,
			()=>{
				console.log("Yes");
				this._ad.show(true);
				this._gamePanel.addShuffle();
				this._container.removeChild(this._sponsorHelp);
				this._sponsorHelp.destroy();
				this.removeUnderground();
			},
			()=>{
				console.log("No");
				this._container.removeChild(this._sponsorHelp);
				this._sponsorHelp.destroy();
				this.removeUnderground();
			});
			this._container.addChild(this._sponsorHelp);
		}
		
		private showGameComplete()
		{
			this.createUnderground();
			this._gameCompletePanel = new GameCompletePanel(this._localizationManager, this._gamePanel.totalScore(),
			this._gamePanel.timeBonus(), this._gamePanel.chainBonus(), this._resources,this._soundManager, this._analytics);
			this._gameCompletePanel.events.once(GameCompletePanel.TRY_AGAIN, () =>
			{
				// this._ad.show(false);
				this._gameCompletePanel.destroy();
				this._container.removeChild(this._gameCompletePanel);
				this._gameCompletePanel = null;

				this.removeUnderground();

				this.playAgain();
			});
			this._container.addChild(this._gameCompletePanel);
		}

		private showLevelComplete()
		{
			this.createUnderground();
			let levelCompletePanel = new LevelCompletePanel(this._localizationManager,
			this._soundManager,
			this._progress,
			this._gamePanel.maxLevels(),
			this._analytics,
			()=>
			{
				this._container.removeChild(levelCompletePanel);
				levelCompletePanel.destroy();

				this.removeUnderground();

				this._gamePanel.nextLevel();

			});
			this._container.addChild(levelCompletePanel);

			this._progress++;
		}

		private playAgain()
		{
			this._progress = 1;

			this._container.removeChild(this._gamePanel);
			this._gamePanel.destroy();
			this._gamePanel = null;

			this.run();
		}

		private createUnderground()
		{
			if (this._graphics != null)
			{
				return;
			}

			this._gamePanel.interactiveChildren = false;
			this.pauseGame();
			
			this._graphics = new Graphics();
			this._graphics.beginFill(0x000000, 0.5);
			this._graphics.drawRect(-this._width * 0.5, -this._height * 0.5, this._width, this._height);
			this._graphics.endFill();
			this._container.addChild(this._graphics);
		}

		private removeUnderground()
		{
			this._graphics.destroy();
			this._container.removeChild(this._graphics);
			this._graphics = null;
			this._gamePanel.interactiveChildren = true;
			this.unPauseGame();
		}

		public update()
		{
			if (this._gamePanel != null)
			{
				this._gamePanel.update();
			}
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Game/Model/GameLifeCycle.ts